import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Modal from "@material-ui/core/Modal";
import ReactPlayer from "react-player";
import { makeStyles } from "@material-ui/core/styles";
// Import Material Icons
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Search from "@material-ui/icons/Search";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import SimpleModal from "./simplemodal";
import LoadingSpinner from "./LoadingSpinner";
import { useParams } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CheckGroup from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";
import { PaginationItem } from "@mui/material";

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 40 + rand();
  const left = 45 + rand();
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    width: 450,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function AgentSalesReport() {
  console.log("=================== agent sales report");
  //const { login } = useParams();
  let fetchURL = ''
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentDate = new Date().getFullYear() + '-' +
    (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' +
    new Date().getDate().toString().padStart(2, '0');
  useEffect(() => {
    fetchURL =
      "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/rms_sales_data?flow=" + agentviewAs;
    //console.log("The login is ->" + login);
    setIsLoading(true);

    fetchPosts();
  }, []);

  const fetchPosts = async (sdate=currentDate, edate=currentDate) => {
    try {
      let postData;

      if (sdate === undefined || edate === undefined) {
        const response = await fetch(fetchURL);
        postData = await response.json();
      } else {
        const searchUrl =
          "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/rms_sales_data/date?flow=" + agentviewAs;
        // sdate = sdate.split("%")[0];
        // edate = edate.split("%")[0];
        const response = await fetch(
          searchUrl + "&startDate=" + sdate + "&endDate=" + edate
        );
        postData = await response.json();
      }

      setPosts(postData);
    } catch (error) {
      console.error("Error fetching posts:", error);
      // You can also set an error state here if needed, e.g., setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const usePosts = posts.map((post) => { });
  console.log(window.location.href);

  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [recordingId, setRecordingId] = React.useState();
  const [audioUrl, setAudioURL] = React.useState();
  const [viewAs, setViewAs] = React.useState("all");
  const [agentviewAs, agentsetViewAs] = React.useState("agent");
  const [viewDaterangeBoolean, setViewDaterangeBoolean] = React.useState(false);
  const [selectedDateRange, setSelectedDateRange] = React.useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleViewChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setViewDaterangeBoolean(true);
    } else {
      setViewDaterangeBoolean(false);
      fetchPosts();
    }
  };

  const handleApiChange = (event) => {
    agentsetViewAs(event.target.value);
    if (event.target.value === "agent") {
      console.log("==========");
      fetchURL =
        "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/rms_sales_data?flow=agent";
      fetchPosts();
    } else if (event.target.value === "qa") {
      console.log("==========QA")
      fetchURL =
        "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/rms_sales_data?flow=qa";
      fetchPosts();
    }
  };
  const handleSelectDateRange = (item) => {
    setSelectedDateRange([item.selection]);
    var newSDate = moment(
      (item.selection.startDate + "").split(" 00:")[0].slice(4),
      "MMM D YYYY"
    ).format("YYYY-MM-DD");
    var newEDate = moment(
      (item.selection.endDate + "").split(" 00:")[0].slice(4),
      "MMM D YYYY"
    ).format("YYYY-MM-DD");
    console.log(newSDate + "=============" + newEDate);
    fetchPosts(newSDate, newEDate);
  };

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const columns = [
    { title: "Customer name", field: "customerData.username" },
    { title: "phone num", field: "customerData.phoneNumber" },
    { title: "Agent Login", field: "customerData.login" },
    { title: "Agent name", field: "customerData.applicant.agentName" },
    { title: "Campaign name", field: "serviceName" },
    { title: "Service Id", field: "customerData.serviceId" },
    { title: "Load id", field: "customerData.loadId" },
    { title: "Call_date", field: "customerData.rdate" },
    { title: "City", field: "customerData.city" },
    { title: "State", field: "customerData.state" },
    { title: "Origin", field: "customerData.origin" },
    // { title: "acwTime", field: "acwTime" },
    // { title: "handlingTime", field: "handlingTime" },
  ];

  return (
    <div className="App wrapper" id="agentlogview">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <FormControl>
            {/* <CheckGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={viewAs}
              onChange={handleViewChange}
            >
              <FormControlLabel
                value="all"
                control={<CheckGroup />}
                label="View All"
              />
              <FormControlLabel
                value="date_range"
                control={<CheckGroup />}
                label="View by Date"
              />
            </CheckGroup> */}
            <FormControlLabel control={<CheckGroup />} label="View by Date" onChange={handleViewChange} />

          </FormControl>{" "}
          <br></br>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-agent-buttons-group-label"
              name="row-radio-agent-buttons-group"
              value={agentviewAs}
              onChange={handleApiChange}
            >
              <FormControlLabel
                value="agent"
                control={<Radio />}
                label="Agent"
              />
              <FormControlLabel
                value="qa"
                control={<Radio />}
                label="Qa Agent"
              />
            </RadioGroup>
          </FormControl>{" "}
          <br></br>
          <br></br>
          {viewDaterangeBoolean ? (
            <DateRangePicker
              onChange={handleSelectDateRange}
              moveRangeOnFirstSelection={false}
              editableDateInputs={true}
              ranges={selectedDateRange}
            />
          ) : (
            <></>
          )}
          <MaterialTable
            title="Agent Sales Report"
            icons={tableIcons}
            columns={columns}
            data={posts}
            localization={{
              toolbar: {
                exportCSVName: "Export as excel",
                exportPDFName: "Export as pdf",
              },
            }}
            options={{
              search: true,
              exportButton: {
                csv: true,
                pdf: true,
              },
              toolbar: true,
              headerStyle: {
                //textAlign: "center",
                // backgroundColor: '#01579b',
                backgroundColor: "#EEE",
                // color: "#FFF",
                fontWeight: "bold",
              },
              // rowStyle: {
              //   backgroundColor: '#EEE',
              // },
              titleStyle: {
                backgroundColor: "#EEE",
              },
              pageSizeOptions: [10, 50, 100, 200, 300, 400, 500, 1000],
            }}
            actions={[
              {
                icon: () => <RefreshIcon />,
                tooltip: "Refresh Data",
                isFreeAction: true,
                onClick: () => {
                  setIsLoading(true);
                  fetchPosts();
                },
              },
            ]}
          />
        </>
      )}

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={classes.paper}>
          {/* <h2>Simple React Modal</h2>
                    <p>
                        RecordingId is {recordingId}
                    </p> */}
          <ReactPlayer
            url={audioUrl}
            //url="http://azpresencedemo.healtheesystems.com:8090/play/"{{recordingId}}".mp3"
            width="400px"
            height="50px"
            playing={false}
            controls={true}
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload",
                },
              },
            }}
          />
        </div>
      </Modal>
    </div>
  );
}

export default AgentSalesReport;
